const localUserData = {
  "locale": "ko-KR",
  "now": "2018-10-10T14:03:16.750+09:00",
  "site": "lineage",
  "guid": "",
  "uesAccountType": "gameAccount",
  "ncAccount": {
    "name": "",
    "profileImage": "",
    "url": "",
    "target": ""
  },
  "gameAccount": {
    "name": "",
    "profileImage": "",
    "url": "",
    "subData": []
  },
  "nshop": {
    "nCoin": "0",
    "coupon": "0"
  },
  "login": false,
  "accountState": []
};

export default localUserData;
